<div ngModelGroup="formulario" #formulario="ngModelGroup">
    <mat-accordion>
        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados</mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngIf="openFormCadastro">
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                        <input matInput [(ngModel)]="categoriaMovimento.dataMovimentacao" name="dataMovimentacao"
                            [matDatepicker]="dataMovimentacao" placeholder="Data" required [max]="maxDate"
                            [min]="minDate" (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataMovimentacao">
                        </mat-datepicker-toggle>
                        <mat-datepicker #dataMovimentacao></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex="20%">
                        <input [(ngModel)]="categoriaMovimento.valor" currencyMask name="valorMovimentacao"
                            placeholder="Valor" required #valorMovimentacao
                            (blur)="validarValorMovimento(valorMovimentacao.value)" matInput maxlength="13"
                            [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                        <span matPrefix>R$&nbsp;</span>
                    </mat-form-field>
                </div>


                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <div ngModelGroup="cbProjeto" fxFlex="49%" fxLayoutGap="20px" class="marginCombo">
                        <combo-projeto [showDisplayId]="false" #campoProjeto
                            [obrigatorio]="!categoriaMovimento.programa?.id" [selecionado]="categoriaMovimento.projeto"
                            (valorChange)="onValorChangeProjeto($event)">
                        </combo-projeto>
                    </div>
                    <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                        <mat-label fxFlexOffset="20px">Tipo (NF/REC/RPA/FOLPAG)</mat-label>
                        <mat-select fxFlexOffset="20px" [(ngModel)]="categoriaMovimento.tipoMovimentacao" name="tipoMovimentacao">
                            <mat-option></mat-option>
                            <mat-option value="N">Nota Fiscal</mat-option>
                            <mat-option value="B">Recibo</mat-option>
                            <mat-option value="R">RPA</mat-option>
                            <mat-option value="F">Folha de Pagamento</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <div ngModelGroup="comboRubricaAdicional" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px"
                        class="marginCombo">
                        <combo-pesquisavel #campoCategoriaDestino nome="rubricaAdicional" [itens]="planosContas"
                            itemDescricao="planoConta" itemId="id" label="Conta Débito" [obrigatorio]="true"
                            placeholder="Escolha..." [(valor)]="categoriaMovimento.categoriaDestino"
                            (valorChange)="carregarContaDestino($event.id)" style="margin-top: 10px;">
                        </combo-pesquisavel>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <div ngModelGroup="comboRubricaOriginal" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px"
                        class="marginCombo">
                        <combo-pesquisavel #campoCategoriaOrigem nome="rubricaOriginal" [itens]="planosContas"
                            itemDescricao="planoConta" itemId="id" label="Conta Crédito" [obrigatorio]="true"
                            placeholder="Escolha..." [(valor)]="categoriaMovimento.categoriaOrigem"
                            (valorChange)="carregarContaOrigem($event.id)" style="margin-top: 10px;">
                        </combo-pesquisavel>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <div ngModelGroup="comboPedidoMaterial" fxFlex="100%" fxFlexOffset="20px" class="marginCombo">
                        <combo-pesquisavel #comboPedidoMaterial nome="comboPedidoMaterial" [itens]="pedidosMateriais"
                            itemDescricao="descricaoPedido" itemId="id" label="Pedido Material" [obrigatorio]="false"
                            placeholder="Escolha..." [(valor)]="categoriaMovimento.pedidosMateriais"
                            style="margin-top: 10px;">
                        </combo-pesquisavel>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <div ngModelGroup="comboContaContabilAdicional" fxFlex="100%">
                        <combo-rubrica [showDisplayId]="false" [hasSintetica]="false"
                            [selecionado]="categoriaMovimento.categoriaAdicional" [label]="'Conta Contábil Adicional'"
                            (valorChange)="carregarContaContabilAdicional($event)"
                            [placeholder]="'Conta Contábil Adicional'">
                        </combo-rubrica>
                    </div>
                </div>


                <div fxLayout="row">
                    <mat-form-field fxFlex="100%" appearance="outline" fxFlexOffset="20px">
                        <mat-label>Histórico</mat-label>
                        <textarea #descricao matInput name="descricao" [(ngModel)]="categoriaMovimento.descricao"
                            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200">
                        </textarea>
                        <mat-hint align="end">{{descricao.value.length}} / 200</mat-hint>
                    </mat-form-field>
                </div>
            </div>



            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]="formulario.invalid"
                    fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>

                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]="formulario.invalid"
                    fxFlex="20%" color="primary" (click)="atualizar()">
                    Atualizar
                </button>

            </div>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span>Lista de Itens ( {{movimentacoes.categoriasMovimentos?.length || 0}} )</span>
                </mat-panel-title>
            </mat-expansion-panel-header>


            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="data">
                    <th mat-header-cell *matHeaderCellDef> Data </th>
                    <td mat-cell *matCellDef="let element"> {{element.dataMovimentacao | dataSimples}} </td>
                </ng-container>

                <ng-container matColumnDef="valor">
                    <th mat-header-cell *matHeaderCellDef> Valor </th>
                    <td mat-cell *matCellDef="let element"> {{element.valor | currency: 'BRL'}} </td>
                </ng-container>

                <ng-container matColumnDef="programaprojeto">
                    <th mat-header-cell *matHeaderCellDef> Projeto</th>
                    <td mat-cell *matCellDef="let element"> {{element.projeto?.nome}} </td>
                </ng-container>

                <ng-container matColumnDef="contacontabil">
                    <th mat-header-cell *matHeaderCellDef> Contas Contábeis </th>
                    <td mat-cell *matCellDef="let element">
                        Conta Destino: {{getRubricaPlanoConta(element.categoriaDestino.id)}} <br />
                        Conta Origem : {{getRubricaPlanoConta(element.categoriaOrigem.id)}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="pedidoMaterial">
                    <th mat-header-cell *matHeaderCellDef> Pedido Material </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.pedidosMateriais?.descricaoPedido}}
                    </td>
                </ng-container>



                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="action-buttons">
                            <button mat-icon-button (click)="copiar(element)" matTooltip="Copiar linha">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                            <button mat-icon-button (click)="deletar(element)" matTooltip="Deletar">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-icon-button (click)="atualizarRegistro(element)" matTooltip="Editar">
                                <mat-icon>create</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar novo item" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</div>
